"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.set = exports.get = void 0;

var _cookies = require("hub-http/helpers/cookies");

var get = function get(key) {
  return (0, _cookies.getCookie)(key, document.cookie);
};

exports.get = get;

var set = function set(key, value) {
  var expiresInMillis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60 * 24 * 60 * 60 * 1000;
  var currentTime = new Date();
  var expiryTime = new Date(currentTime.setTime(currentTime.getTime() + expiresInMillis)).toUTCString();
  document.cookie = key + "=" + value + ";expires=" + expiryTime + ";path=/";
};

exports.set = set;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker/static-1.514/js/helpers/cookieHelper.js
// module id = 380
// module chunks = 5 6